<template>
    <v-container fluid>
        <v-row>
            <v-col class="text-right">
                <v-btn icon large :loading="downloading" @click="download">
                    <v-icon>
                        mdi-download
                    </v-icon>
                </v-btn>
                <toggle-filter-btn />
            </v-col>
        </v-row>
        <v-data-table
            :headers="headers"
            :items="data"
            :loading="loading"
            class="elevation-3"
        >
            <template v-slot:footer>
                <v-responsive
                    width="100%"
                    class="pa-2 grey lighten-3 text-center"
                >
                    <v-row>
                        <v-col cols="12" xs="12" md="4" lg="3">
                            <span class="text-h6">
                                {{ $t('reports.bookings.table.bookings') }}:
                            </span>
                            <strong>{{ totals.count }}</strong>
                        </v-col>
                        <v-col cols="12" xs="12" md="4" lg="3">
                            <span class="text-h6">
                                {{ $t('reports.bookings.table.totalGross') }}:
                            </span>
                            <strong>{{ $n(totals.gross, 'currency') }}</strong>
                        </v-col>
                        <v-col cols="12" xs="12" md="4" lg="3">
                            <span class="text-h6">
                                {{ $t('reports.bookings.table.discounts') }}:
                            </span>
                            <strong>{{
                                $n(totals.discounts, 'currency')
                            }}</strong>
                        </v-col>
                        <v-col cols="12" xs="12" md="4" lg="3">
                            <span class="text-h6">
                                {{ $t('reports.bookings.table.totalNet') }}:
                            </span>
                            <strong>{{ $n(totals.net, 'currency') }}</strong>
                        </v-col>
                    </v-row>
                </v-responsive>
            </template>
            <template v-slot:[`item.price`]="{ item }">
                <span v-bind:class="{ 'red--text': !item.integrity }">
                    {{ $n(item.price, 'currency') }}
                </span>
            </template>
            <template v-slot:[`item.discounts`]="{ item }">
                {{ $n(item.discounts, 'currency') }}
            </template>
            <template v-slot:[`item.final_price`]="{ item }">
                {{ $n(item.final_price, 'currency') }}
            </template>
        </v-data-table>
    </v-container>
</template>

<script>
import axios from '@/plugins/axios'
import i18n from '@/plugins/i18n'
import ToggleFilterBtn from '@/shared/components/filters/ToggleFilterBtn'

export default {
    components: {
        ToggleFilterBtn,
    },

    data() {
        return {
            loading: true,
            data: undefined,
            downloading: false,
            totals: false,
        }
    },

    watch: {
        filters() {
            this.fetchData()
        },

        data() {
            this.calcTotals()
        },
    },

    computed: {
        filterKey() {
            return 'bookingsReport'
        },

        filters() {
            return this.$store.getters['filters/current'][this.filterKey]
        },

        filtersQuery() {
            return this.$store.getters['filters/queryString'](this.filterKey)
        },

        headers() {
            return [
                {
                    text: i18n.t('reports.bookings.table.vcode'),
                    value: 'vcode',
                    sortable: false,
                },
                {
                    text: i18n.t('reports.bookings.table.active_at'),
                    value: 'active_at',
                    sortable: false,
                },
                {
                    text: i18n.t('reports.bookings.table.month_year'),
                    value: 'month_year',
                    sortable: false,
                },
                {
                    text: i18n.t('reports.bookings.table.schema'),
                    value: 'schema',
                    sortable: false,
                },
                {
                    text: i18n.t('reports.bookings.table.customer.id'),
                    value: 'customer_id',
                    sortable: false,
                },
                {
                    text: i18n.t('reports.bookings.table.customer.trade_name'),
                    value: 'trade_name',
                    sortable: false,
                },
                {
                    text: i18n.t('reports.bookings.table.customer.legal_name'),
                    value: 'legal_name',
                    sortable: false,
                },
                {
                    text: i18n.t('reports.bookings.table.reseller.id'),
                    value: 'reseller_id',
                    sortable: false,
                },
                {
                    text: i18n.t('reports.bookings.table.reseller.trade_name'),
                    value: 'reseller_trade_name',
                    sortable: false,
                },
                {
                    text: i18n.t('reports.bookings.table.subject'),
                    value: 'subject',
                },
                {
                    text: i18n.t('reports.bookings.table.price'),
                    value: 'price',
                },
                {
                    text: i18n.t('reports.bookings.table.discounts'),
                    value: 'discounts',
                },
                {
                    text: i18n.t('reports.bookings.table.final_price'),
                    value: 'final_price',
                },
            ]
        },
    },

    methods: {
        fetchData() {
            this.loading = true
            let url = '/reports/booking?' + this.filtersQuery

            axios
                .get(url)
                .then(response => {
                    this.data = Object.values(response.data.data)
                    this.setFilters(response.data.meta.filters)
                    this.loading = false
                })
                .catch(error => {
                    this.$bus.$emit('notify', 'error', 'Ocorreu um erro.')
                    this.loading = false
                    return error
                })
        },

        async download() {
            this.downloading = true
            let url = '/reports/booking/download?' + this.filtersQuery

            await this.$http.get(url).then(response => {
                if (response) {
                    this.$bus.$emit('notify', 'success', response.data.message)
                }
            })

            this.downloading = false
        },

        async calcTotals() {
            let totals = { count: 0, gross: 0, discounts: 0, net: 0 }

            this.data.forEach(element => {
                totals.count++
                totals.gross += element.price
                totals.discounts += element.discounts
                totals.net += element.final_price
            })

            this.totals = totals
        },

        async setFilters(filters) {
            this.$bus.$emit('filters', {
                resource: this.filterKey,
                allowed: filters.allowed,
            })
            this.hasFilters = true
        },
    },
    mounted() {
        this.fetchData()
    },
}
</script>

<style></style>
